import { useSelector } from "react-redux"
import type { QuerySubState } from "@reduxjs/toolkit/query"
import type { BaseEndpointDefinition } from "@reduxjs/toolkit/query"

import AlertsTable from "widgets/alerts/AlertsTable"
import DateRangePicker from "widgets/dates/DateRangePicker"
import { SectionContainer } from "widgets/styled/containers"
import type { DateRange } from "types/date.types"
import type { RootState } from "features/store"

interface AlertsContainerProps {
  dateRange: DateRange | null
  dispatchDateRange: (dateRange: DateRange) => void
  isDateRangeValid: boolean
  devicesIds?: number[]
  groupId?: number
  showDatePicker?: boolean
}

const AlertsContainer = ({
  dateRange,
  dispatchDateRange,
  isDateRangeValid,
  devicesIds,
  groupId,
  showDatePicker = true,
}: AlertsContainerProps) => {
  const isFetching = useSelector((state: RootState) => {
    const queries = Object.values(state.api.queries)
    return queries.some(
      (query: QuerySubState<BaseEndpointDefinition<any, any, any>> | undefined) =>
        query?.status === "pending",
    )
  })

  return (
    <SectionContainer disableGutters maxWidth="xl">
      <AlertsTable
        dateRange={dateRange}
        isDateRangeValid={isDateRangeValid}
        devicesIds={devicesIds}
        groupId={groupId}
        toolbarControl={
          showDatePicker ? (
            <DateRangePicker
              dateRange={dateRange}
              dispatchDateRange={dispatchDateRange}
              isFetching={isFetching}
            />
          ) : undefined
        }
      />
    </SectionContainer>
  )
}

export default AlertsContainer
